import React from 'react';
import { Edit, useForm } from '@refinedev/antd';
import { Form, Input } from 'antd';
import { LocalizedContentTabs, normalizeTranslations } from '../../components/LocalizedContentTabs';

const LANG_FIELDS = [
  { key: 'defaultText', translationKey: 'text', label: 'Text', textarea: true, required: true },
];

export const SystemMessageEdit: React.FC = () => {
  const { formProps, saveButtonProps, queryResult } = useForm({ resource: 'system-messages' });

  return (
    <Edit resource="system-messages" saveButtonProps={saveButtonProps}>
      <Form
        {...formProps}
        layout="vertical"
        onFinish={(values: any) =>
          formProps.onFinish?.({
            ...values,
            translations: normalizeTranslations(values.translations, LANG_FIELDS, queryResult?.data?.data?.translations),
          })
        }
      >
        <LocalizedContentTabs fields={LANG_FIELDS} />
        <Form.Item label="Key" name="key" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item label="Namespace" name="namespace" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item label="Description" name="description">
          <Input.TextArea rows={2} />
        </Form.Item>
      </Form>
    </Edit>
  );
};
